var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShengji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1771550597155,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 72626,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M513.058744 2.142548C334.249979 2.142548 176.904279 93.971393 85.614203 233.049054q-5.46287 8.307071-10.587443 16.839673-5.550577 9.171608-10.67515 18.606336-2.230254 4.084623-4.372803 8.194305a510.991374 510.991374 0 0 0 708.5443 678.84934q13.368997-7.705654 26.124048-16.15055 3.884151-2.581081 7.705654-5.19975 8.870899-6.089346 17.428561-12.529519 7.968774-6.00164 15.674428-12.25387a510.978844 510.978844 0 0 0 188.531672-396.333745c0-282.177298-228.751429-510.928726-510.928726-510.928726z",
    fill: "#C8B0A4",
    "p-id": 72627
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M604.298702 1015.893401a518.296083 518.296083 0 0 1-182.479915 0V774.224039H604.298702z m0 0",
    fill: "#7F4D27",
    "p-id": 72628
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M553.54162 1022.408751c-13.343938 1.027421-26.800641 1.591249-40.482876 1.591249-10.374442 0-20.636118-0.338297-30.797557-0.902125l78.585143-154.651853a158.235296 158.235296 0 0 1-48.363944 7.29218c-38.089738 0-71.505965-12.529519-90.663599-31.323798v-70.165306H604.298702v68.912354l-1.252952 1.252952 1.252952 1.027421v83.484185z m0 0",
    fill: "#5A371B",
    "p-id": 72629
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.733258 928.65036l206.085529-100.825039 33.767054 192.954593a508.372704 508.372704 0 0 1-239.852583-92.154613z m354.585388 92.154613l33.992585-192.954593 206.072999 100.825039a509.111946 509.111946 0 0 1-240.065584 92.154613z m0 0",
    fill: "#7F271F",
    "p-id": 72630
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M835.468327 911.146622q-7.267121 5.901403-14.784832 11.552217-8.056481 6.039228-16.438729 11.790277-3.583442 2.505904-7.254591 4.899042L104.358364 314.641281 11.151272 230.54315l-1.3156-1.190305a23.367553 23.367553 0 0 1 31.323798-34.706767l87.393395 78.823204z",
    fill: "#F3BD50",
    "p-id": 72631
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.541779 289.431889L820.683495 922.698839q-8.056481 6.039228-16.438729 11.790277-3.583442 2.505904-7.254591 4.899042L104.358364 314.641281 11.151272 230.54315l-1.3156-1.190305a23.430201 23.430201 0 0 1-6.465231-24.871095A23.505378 23.505378 0 0 1 28.817894 208.40349z",
    fill: "#F3A81C",
    "p-id": 72632
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.480576 306.973216l695.77672 627.5159q-3.583442 2.505904-7.254592 4.899042L104.345834 314.653811 11.151272 230.54315a21.87654 21.87654 0 0 1 2.205195-0.213002 23.167081 23.167081 0 0 1 16.839674 5.951521z",
    fill: "#A37323",
    "p-id": 72633
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M455.585841 1020.804973c-10.838034-1.252952-21.450537-2.743965-32.05051-4.560745l-80.965752-149.640046 62.647595-30.622144 24.407503 52.072681z m146.883551-4.560745c-10.599973 1.81678-21.438007 3.420559-32.276041 4.67351L596.405105 888.167484l26.111517-51.371028 61.507409 30.070846z m0 0",
    fill: "#FFFFFF",
    "p-id": 72634
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M285.196912 530.62513c-5.362634-144.84124 110.259767-255.915426 227.749067-255.915426 116.887883 0 232.773404 112.765671 228.037246 253.973351 6.966413-4.097153 13.581999-5.4754 19.395695-3.420559 18.581277 6.841117 21.212476 46.872931 5.700931 89.410648s-43.226841 71.63126-61.820647 64.902908a7.592889 7.592889 0 0 1-0.902125-0.350827c-42.19942 94.096688-113.028791 159.901722-190.348453 159.901722-77.89602 0-149.740282-65.153499-191.701641-160.578316-0.676594 0.338297-1.478483 0.676594-2.280372 1.027421-18.593806 6.841117-46.35922-22.239896-61.808117-64.902908s-13.005641-82.694825 5.700931-89.410648c6.50282-2.280372 14.258593-0.225531 22.239896 5.362634z m0 0",
    fill: "#986E50",
    "p-id": 72635
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M608.50862 675.99261a102.328582 102.328582 0 1 1-194.382958 0 102.328582 102.328582 0 1 1 97.191479-162.583039 102.328582 102.328582 0 1 1 97.191479 162.583039z",
    fill: "#FAD5D5",
    "p-id": 72636
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M513.058744 744.378724c-19.846758 0-35.922131 6.477761-35.922131 14.446536h71.844262c0-7.968774-16.087902-14.446535-35.922131-14.446536z",
    fill: "#C83232",
    "p-id": 72637
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M514.963231 652.361937a15.874901 15.874901 0 0 0-15.987666 15.762135h31.962803A15.874901 15.874901 0 0 0 514.963231 652.361937z",
    fill: "#9A6343",
    "p-id": 72638
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M457.590564 596.204632a37.287849 37.287849 0 0 1-68.611646-29.193779z",
    fill: "#6D2700",
    "p-id": 72639
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M388.866152 566.83544a37.275319 37.275319 0 0 1 68.611646 29.18125zM632.239529 566.83544a37.275319 37.275319 0 0 0-68.611646 29.18125z",
    fill: "#F4BDBD",
    "p-id": 72640
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M563.515117 596.204632a37.287849 37.287849 0 0 0 68.611646-29.193779z",
    fill: "#6D2700",
    "p-id": 72641
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M499.852631 249.901257s-71.142609 36.849315-85.376142 102.391229 82.080879-50.656845 82.080879-50.656845-11.664982-35.834424 3.295263-51.734384z",
    fill: "#986E50",
    "p-id": 72642
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M566.797851 231.006742s-77.683018 19.633756-106.500911 80.188922 91.465489-30.572026 91.465489-30.572027-3.107321-37.550968 15.035422-49.616895z",
    fill: "#986E50",
    "p-id": 72643
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M577.460472 254.261529s-74.50052 29.507017-95.224344 93.282269 86.74186-42.136772 86.74186-42.136772-7.956245-36.824256 8.482484-51.145497z",
    fill: "#986E50",
    "p-id": 72644
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M577.610826 1020.003083a524.89914 524.89914 0 0 1-129.054045 0l-91.778727-160.277607 65.040733-31.900155 91.239957 179.397653L604.298702 827.825321l65.153499 31.837508z m0 0",
    fill: "#D4914A",
    "p-id": 72645
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M270.637611 554.117978c8.770663 0.626476 14.408947 2.756494 21.300182 17.040146s-4.385332 31.198502 0 41.848593 8.144187 23.806086 18.794278 29.469429c0 0 0 10.574914-5.638283 10.913211-3.069732 0.187943-26.023811-22.716018-34.456177-49.641954-7.04159-22.377721 0-49.629425 0-49.629425zM753.024092 554.117978c-8.770663 0.626476-14.408947 2.756494-21.300182 17.040146s4.385332 31.198502 0 41.848593-8.144187 23.806086-18.794278 29.469429c0 0 0 10.574914 5.638283 10.913211 3.082262 0.187943 26.023811-22.716018 34.456177-49.641954 6.991472-22.377721 0-49.629425 0-49.629425z",
    fill: "#7A573E",
    "p-id": 72646
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M481.13353 562.775876s-13.243702 7.868538-23.19214 0-61.394643-29.732549-61.394643-29.732549M540.022269 562.775876s13.256231 7.868538 23.204669 0 61.394643-29.732549 61.394644-29.732549",
    fill: "#BE9393",
    "p-id": 72647
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShengji);
export default __webpack_public_path__ + "static/media/shengji.5a89b3a0.svg";
export { ForwardRef as ReactComponent };